import script from "./EmployeeAvatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmployeeAvatar.vue?vue&type=script&setup=true&lang=ts"

import "./EmployeeAvatar.vue?vue&type=style&index=0&id=367492ea&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-367492ea"]])

export default __exports__